import type { ShadowRunListItem } from "../types";

/** Resolve the Temporal workflow id used for invocation/progress routes. */
export function getShadowRunWorkflowId(
  item: Pick<ShadowRunListItem, "id" | "workflowId">,
): string {
  // Use `||` not `??`: workflowId is `z.string().optional()`, so the API may
  // return "". An empty string must fall back to `id` to keep React keys unique
  // and avoid a dead progress route that won't match the `:workflowId` segment.
  return item.workflowId || item.id;
}

/**
 * Compact label for run lists. Prefers batch id when present, otherwise the
 * last 8 characters of the workflow run segment (dashes stripped). This is a
 * display-only label and is not guaranteed to be unique.
 */
export function formatShadowRunListLabel(
  workflowId: string,
  batchId?: string | null,
): string {
  if (batchId) return batchId;

  const runSegment = workflowId.includes("_")
    ? workflowId.slice(workflowId.lastIndexOf("_") + 1)
    : workflowId;
  const compact = runSegment.replace(/-/g, "");
  if (compact.length <= 8) return compact;
  return compact.slice(-8);
}

export function shadowRunProgressPath(agentId: string, workflowId: string): string {
  return `/shadow-runs/progress/${agentId}/${encodeURIComponent(workflowId)}`;
}
